import { FileInputBlock as FileInputBlockType } from '@coast/schemas/index';
import { useCallback, useMemo } from 'react';
import { useCardFormContext } from '@shared/components/blocks/contexts/form';
import { FileUpload } from '@shared/components/blocks/types';
import { renderError } from '../input/utils';
import { FileInput } from './FileInput';

interface Props {
  block: FileInputBlockType;
}

export function FileInputBlock({ block }: Props) {
  const { setFieldValue, values, errors } = useCardFormContext();

  const error = errors[block.name];
  const files: FileUpload[] = useMemo(() => values[block.name] ?? [], [block.name, values]);

  const onFileAdded = useCallback(
    file => {
      const newValues = [...files];
      newValues.push(file);
      setFieldValue(block.name, newValues);
    },
    [block.name, files, setFieldValue],
  );

  const onFileRemoved = useCallback(
    file => {
      const newValues = files.filter(value => {
        return value.url !== file.url;
      });
      setFieldValue(block.name, newValues);
    },
    [block.name, files, setFieldValue],
  );

  return (
    <>
      <FileInput
        label={block.label}
        files={files}
        error={!!error}
        placeholder={block.placeholder}
        icon={block.icon}
        acceptedContentTypes={block.acceptedContentTypes}
        onFileAdded={onFileAdded}
        onFileRemoved={onFileRemoved}
      />
      {renderError(block)}
    </>
  );
}
